import { h } from '@stencil/core';
import state from 'store';
import { i18n } from 'i18n';
import { sendFeedbackMessage } from 'client';
import { buildRequestContext } from 'client/helper';
import initParams from 'store/initParams';
import { triggerTrackEvent, triggerUpdateMessage } from 'utils/events';

export default function FeedbackModal({ show }: { show: boolean }) {
  const onClose = () => {
    state.showFullScreenModal = null;
  };

  const onSend = () => {
    triggerTrackEvent({
      event_type: 'user',
      event_name: `feeback_send`,
      data: { type: state.feedback.type?.toLowerCase() ?? 'undefined' },
    });

    sendFeedbackMessage(
      state.chatId ?? 'undefined',
      state.feedback.messageId ?? 'undefined',
      {
        text: state.feedback.text !== '' ? state.feedback.text : undefined,
        action: state.feedback.type === 'LIKE' ? 'LIKE' : 'DISLIKE',
      },
      buildRequestContext(state, initParams),
    )
      .then(() => {
        // console.log(`Succesfully feedback message ${state.feedback.messageId} with type ${state.feedback.type}`);
        if (state.feedback.messageId !== null) {
          triggerUpdateMessage({
            messageId: state.feedback.messageId,
            message: {
              feedback: state.feedback.type,
            },
          });
        }
      })
      .catch(e => {
        console.error(e);
      })
      .finally(() => {
        onClose();
      });
  };

  return show ? (
    <div
      id={'feedback-modal'}
      role="presentation"
      class={{
        'eva-3-modal -show-sticky-footer -smooth-scroll fullscreen-modal -show-modal': true,
      }}
    >
      <div class="modal-header" role="presentation">
        <div class="modal-title-container">
          <h4 class="eva-3-h4 modal-title">
            <i class={`${state.feedback.type === 'LIKE' ? 'eva-3-icon-thumbs-up' : 'eva-3-icon-thumbs-down'} -eva-3-icon-md -eva-3-mr-md`} />{' '}
            {state.feedback.type === 'LIKE' ? i18n.t.chat.message.feedback.upTitle : i18n.t.chat.message.feedback.downTitle}
          </h4>
        </div>
        <i
          class="eva-3-icon-cross modal-close -eva-3-mr-md"
          role="button"
          tabindex="0"
          aria-label={i18n.t.chat.message.feedback.close}
          onClick={() => {
            triggerTrackEvent({
              event_type: 'user',
              event_name: `feeback_close`,
              data: { type: state.feedback.type?.toLowerCase() ?? 'undefined' },
            });
            onSend();
          }}
        ></i>
      </div>
      <div class="modal-content" role="presentation">
        <div class="eva-3-textarea -lg ">
          <div class="textarea-container">
            <textarea
              class="textarea-tag"
              value={state.feedback.text}
              onKeyUp={event => {
                state.feedback = {
                  ...state.feedback,
                  text: (event.target as HTMLTextAreaElement).value,
                };
              }}
              placeholder={i18n.t.chat.message.feedback.placeholder}
              rows={4}
              data-twofas-input-listener="true"
              maxlength={500}
            ></textarea>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="eva-3-btn -lg -primary" onClick={onSend}>
          <em class="btn-text">{i18n.t.chat.message.feedback.sendButton}</em>
        </button>
      </div>
    </div>
  ) : null;
}
